import { onAuthStateChanged } from '@firebase/auth';
import {
    collection,
    doc,
    query,
    where,
    getDocs,
    setDoc,
    updateDoc,
    deleteDoc
} from '@firebase/firestore';

import { db, auth } from '../FirebaseConfig';
import { DATABASE_COLLECTIONS } from '../constants/DatabaseCollections';
import { deleteSplitById } from './Splits';

let user;

onAuthStateChanged(auth, currentUser => {
    user = currentUser
})

export const createProject = async (title, description, solde) => {
    const dateNow = Date.now()

    const project = {
        projectId: user.uid + dateNow.toString(),
        uid: user.uid,
        title: title,
        description: description,
        creationDate: dateNow,
        solde: solde,
        splits: [],
    }

    let docRef = doc(db, DATABASE_COLLECTIONS.PROJECTS, project.projectId)

    const sendRequest = await setDoc(docRef, project)
        .then(() => {
            return project;
        })
        .catch(err => {
            throw new Error(err);
        })

    return sendRequest;
}

export const getAllProjects = async () => {
    let collectionRef = collection(db, DATABASE_COLLECTIONS.PROJECTS)

    let q = query(collectionRef, where('uid', '==', user.uid));
    let querySnapshot = await getDocs(q);

    let allProjects = []

    querySnapshot.forEach((doc) => {
        let project = doc.data()
        allProjects.push(project)
    });

    return allProjects
}

export const modifyProjectSolde = async (projectId, newSolde) => {
    let docRef = doc(db, DATABASE_COLLECTIONS.PROJECTS, projectId)

    const sendRequest = await updateDoc(docRef, {
        solde: newSolde,
    }).then(() => {
        return;
    }).catch(err => {
        throw err
    })

    return sendRequest

}

export const deleteProjectById = async (projectId, splitsArr) => {

    splitsArr.map((split) => {
        deleteSplitById(split.splitId)
            .catch(err => {
                throw new Error(err)
            })
    })

    let docRef = doc(db, DATABASE_COLLECTIONS.PROJECTS, projectId)

    const sendRequest = await deleteDoc(docRef)
        .then(() => {
            return
        })
        .catch(err => {
            throw new Error(err);
        })

    return sendRequest;
}

export const modifyProject = async (projectId, title, description, solde) => {
    let docRef = doc(db, DATABASE_COLLECTIONS.PROJECTS, projectId)

    await updateDoc(docRef, {
        title: title,
        description: description,
        solde: solde
    }).then(() => {
        return;
    }).catch(err => {
        throw err
    })
}
